import React, { useState, useEffect } from "react";
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";
import ContentHeader from "../ContentHeader";
import { Outlet } from "react-router-dom";
import ChatWidget from "../ChatWidget";



const Layout = ({ onLogout }) => {
  // 1. Initial State: Tablet/Mobile (<= 992px) hai to TRUE
  // 992px isliye taaki Tablets par bhi Mobile wala view mile
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 992);

  const [sidebarOpen, setSidebarOpen] = useState(window.innerWidth > 992);

 
  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 992; 

      setIsMobile((prevIsMobile) => {
       
        if (prevIsMobile !== mobile) {
          if (mobile) {
             setSidebarOpen(false); 
          } else {
             setSidebarOpen(true);  
          }
          return mobile;
        }
        return prevIsMobile;
      });
    };

    window.addEventListener("resize", handleResize);
    
    // Cleanup function memory leak rokne ke liye
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // 3. Toggle Function
  const toggleSidebar = () => {
    setSidebarOpen((prev) => !prev);
  };

  return (
    <div className="layout-container d-flex flex-column vh-100">
      {/* Navbar ko toggle function pass kiya */}
      <Navbar toggleSidebar={toggleSidebar} />

      <div className="d-flex flex-grow-1 position-relative overflow-hidden">
        
        {/* --- MOBILE OVERLAY (Black Background) --- */}
        {/* Sirf tab dikhega jab Mobile ho aur Sidebar khula ho */}
        {isMobile && sidebarOpen && (
          <div 
            className="sidebar-overlay" 
            onClick={() => setSidebarOpen(false)} // Overlay click par band karein
          ></div>
        )}

        {/* --- SIDEBAR --- */}
        {/* React Conditional Rendering: Sidebar tabhi DOM me aayega jab open ho */}
        {sidebarOpen && (
          <div className="col-2-5 bg-white h-100 shadow-sm sidebar-wrapper">
            <Sidebar 
              onLogout={onLogout} 
              // Mobile par kisi link par click karne se sidebar band ho jaye
              onLinkClick={() => isMobile && setSidebarOpen(false)} 
            />
          </div>
        )}

        {/* --- MAIN CONTENT --- */}
        <div className="flex-grow-1 overflow-auto p-0  bg-light main-content-area">
          <div className="m-0 p-0" style={{ padding: 'clamp(4px, 0.4vw, 6px)' }}>
            {/* ContentHeader me Toggle button ke liye prop pass kiya */}
            <ContentHeader toggleSidebar={toggleSidebar} />
          </div>
          {/* Outlet me pages render honge */}
          <div style={{ padding: '0 clamp(4px, 0.4vw, 6px)' }}>
            <Outlet />
          </div>
        </div>

      </div>
      {/*<ChatWidget /> */}
    </div>
  );
};

export default Layout;